<div class="back">
  <button *ngIf="isLibrary" (click)="moveBack()" class="back-btn">
    <img
      style="margin-right: 5px; font-weight: 600"
      src="../../assets/back.svg"
      alt="back"
    />Go Back
  </button>
</div>
<div
  [ngStyle]="{ 'margin-top': isLibrary ? '4vh' : '0vh' }"
  *ngIf="is_display || isLibrary"
  id="guidelines_input_screen_container"
>
  <div>
    <div class="guidelines_header">
      <div class="user_header">
        <em
          class="bi bi-person"
          style="font-size: 1.3rem; margin-right: 0.6vw"
        ></em>
        User
      </div>
      <div class="view-edit-text">
        <div>View only</div>
        <div *ngIf="selectedCategory == 'npds' && !isLibrary">/</div>
        <div *ngIf="selectedCategory == 'npds' && !isLibrary">Edit NPD</div>
      </div>
      <div class="content">
        <div class="category">
          <div *ngFor="let category of categories">
            <div
              style="
                padding: 0.5vw;
                border-radius: 0.2vw;
                font-weight: 600;
                font-size: 0.95vw;
                cursor: pointer;
              "
              [ngClass]="{ selected: selectedCategory == category }"
              (click)="changeCategory(category)"
            >
              {{ category.toUpperCase()
              }}<img
                style="margin-left: 0.5vw; height: 1.5vh"
                [src]="
                  selectedCategory == category
                    ? '../../assets/lock_white.png'
                    : '../../assets/lock.png'
                "
              />
            </div>
          </div>
        </div>
      </div>
      <div
        [ngClass]="{
          selected: selectedCategory == 'npds',
          disabled: isDisabled
        }"
        (click)="changeCategory('npds')"
        class="npd_edit"
      >
        <em
          *ngIf="!isLibrary"
          class="bi bi-pencil"
          style="font-size: 1rem; cursor: pointer; margin-right: 0.6vw"
        ></em>
        NPD
      </div>
    </div>
    <div class="note">
      <div
        *ngIf="
          guidelines_input &&
          guidelines_input.methodology &&
          guidelines_input.methodology[
            selectedCategory == 'npds' ? 'NPD' : selectedCategory
          ]
        "
      >
        {{
          guidelines_input.methodology[
            selectedCategory == "npds" ? "NPD" : selectedCategory
          ].heading
        }}
      </div>
    </div>
    <div style="display: flex; gap: 10%; margin: 1.5vw">
      <div style="width: 47%; height: 47vh; overflow: auto">
        <table
          *ngIf="dataSource.data.length > 0"
          class="sku-table"
          mat-table
          #mytable
          [dataSource]="dataSource"
        >
          <ng-container matColumnDef="no">
            <th
              style="
                padding-left: 10px;
                width: 60px;
                width: 6%;
                font-size: 0.95vw;
                font-weight: 600;
              "
              mat-header-cell
              *matHeaderCellDef
            >
              SKU
            </th>
            <td
              mat-cell
              style="padding-bottom: 1.5vh"
              *matCellDef="let data; let i = index"
            >
              {{ i + 1 }}.
            </td>
          </ng-container>
          <ng-container matColumnDef="sku_img">
            <th
              style="padding-left: 10px; width: 60px; width: 10%"
              mat-header-cell
              *matHeaderCellDef
            ></th>
            <td
              mat-cell
              style="padding-bottom: 1.5vh"
              *matCellDef="let data; let i = index"
            >
              <div *ngIf="sku_images_array[i] == 'loading'">
                <mat-spinner diameter="24"></mat-spinner>
              </div>
              <img
                *ngIf="sku_images_array[i] !== 'loading' && data.sku_image_uri"
                style="height: 10vh; margin-bottom: 1.5vh"
                [src]="sku_images_array[i]"
              />
            </td>
          </ng-container>
          <ng-container matColumnDef="dropdown">
            <th
              style="padding-left: 10px; width: 60px"
              mat-header-cell
              *matHeaderCellDef
            ></th>
            <td
              mat-cell
              style="padding-bottom: 1.5vh"
              *matCellDef="let data; let i = index"
            >
              <mat-form-field *ngIf="selectedCategory !== 'npds'">
                <mat-select
                  [disabled]="selectedCategory !== 'npds'"
                  value="data.sku_name"
                >
                  <mat-option value="data.sku_name">
                    {{ data.sku_face }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field *ngIf="selectedCategory == 'npds'">
                <mat-select
                  [disabled]="isLibrary"
                  [value]="npds_dropdown_selected[i].product_name"
                >
                  <mat-option
                    *ngFor="let npd of npds_dropdown_value"
                    [value]="npd.product_name"
                    (click)="selectNpds(npd, i)"
                  >
                    {{ npd.product_name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </td>
          </ng-container>
          <ng-container matColumnDef="sku_face">
            <th
              style="
                padding-left: 10px;
                width: 60px;
                width: 8%;
                font-size: 0.95vw;
                font-weight: 600;
              "
              mat-header-cell
              *matHeaderCellDef
            >
              Facings
            </th>
            <td
              style="padding-bottom: 1.5vh"
              mat-cell
              *matCellDef="let data; let i = index"
            >
              <div class="increment_decrement_container">
                <button
                  [disabled]="true"
                  (click)="decrementNpdFacings(data, i)"
                  class="minus"
                >
                  -
                </button>
                <input
                  style="width: 3vw; height: 4vh; font-size: 0.9vw"
                  [value]="
                    selectedCategory == 'npds'
                      ? npds_dropdown_selected[i].facings
                      : data.base_facings
                  "
                  type="text"
                  class="input-number npd_counter_value"
                />
                <button
                  [disabled]="true"
                  (click)="incrementNpdFacings(data, i)"
                  class="plus"
                >
                  +
                </button>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: columns"></tr>
        </table>
      </div>
      <div class="methodology-section">
        <div style="width: 100%">
          <div class="heading">Methodology</div>
          <div class="methodology_box">
            <div>
              <img src="../../assets/idea_icon.png" alt="idea-icon" />
            </div>
            <div
              *ngIf="
                guidelines_input.methodology &&
                guidelines_input.methodology[
                  selectedCategory == 'npds' ? 'NPD' : selectedCategory
                ]
              "
            >
              <ng-container
                *ngFor="
                  let segment of renderHtml(
                    guidelines_input.methodology[
                      selectedCategory == 'npds' ? 'NPD' : selectedCategory
                    ].description
                  )
                "
              >
                <b *ngIf="segment.isBold">{{ segment.text }}</b>
                <span *ngIf="!segment.isBold">{{ segment.text }}</span>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
